import { useState } from "react"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { getScheduleSummary } from "routes/schedule/plugins/ai-summary/controller/get-schedule-summary"
import { StyledToolTip } from "lib/@components/styled-tool-tip"
import { IconButton, Typography } from "@mui/material"
import { BlockClicks } from "lib/@components/block-clicks"
import Iconify from "minimals-template/components/Iconify"
import { createEvent } from "library/local-events/index.mjs"

export const ScheduleSummaryTooltip = createEvent("ScheduleSummaryTooltip")

export function Summary({ placement = "right", focused }) {
    const { schedule, summaryTooltipId } = useBoundContext()
    const summary = getScheduleSummary.useResults(schedule._id)
    const [isTooltipOpen, setIsTooltipOpen] = useState(false)

    ScheduleSummaryTooltip(schedule?._id).useEvent(handleScheduleSummaryTooltip, [schedule?._id])

    if (summary) {
        return (
            <BlockClicks>
                <StyledToolTip
                    id={summaryTooltipId}
                    arrow
                    placement={placement}
                    enterNextDelay={300}
                    title={
                        <Typography sx={{ lineHeight: 1.1 }} variant="body2">
                            {summary}
                        </Typography>
                    }
                    enterDelay={300}
                    open={focused || isTooltipOpen}
                    onOpen={showTooltip}
                    onClose={hideTooltip}
                >
                    <IconButton
                        data-cy="schedule-ai-summary-trigger"
                        size="small"
                        color="primary"
                        aria-label={triggerLabel()}
                        sx={{ ml: 1 }}
                    >
                        <Iconify icon="material-symbols:info-outline" />
                    </IconButton>
                </StyledToolTip>
            </BlockClicks>
        )
    }
    return null

    function triggerLabel() {
        const name = schedule?.label ?? schedule?.title
        if (!name) return "Show schedule summary"
        return `Show the summary of ${name}`
    }

    function handleScheduleSummaryTooltip({ open }) {
        setIsTooltipOpen(open)
    }

    function showTooltip() {
        setIsTooltipOpen(true)
    }

    function hideTooltip() {
        setIsTooltipOpen(false)
    }
}
